import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IabandonedApps,IaddnewAssociations,Iassociation, Idropdown, IHome, Ipremiumtranscations } from "../sidenav/helper";
import { coreService } from "./coreService";


@Injectable({
  providedIn: 'root'
})
export class HomeService {
apiUrl!:string;
  constructor(private http: HttpClient,private coreService :coreService) { this.apiUrl=coreService.getAPi();}

  getMasterPolicyData(id: number) {
    if (id <= 0)
      return this.http.get<IHome[]>(this.apiUrl+'masterpolicy/Get');
    else
      return this.http.get<IHome[]>(this.apiUrl+'masterpolicy/Get/' + id);

  }
  //getPremiumTransactions
  getMasterPoliciesPremium(Id: number) {
    return this.http.get<Ipremiumtranscations[]>(this.apiUrl+'masterpolicy/GetPremiumTransactionsByMasterPolicyId/' + Id);
  }
  GetPremiumTransactions() {
    return this.http.get<Ipremiumtranscations[]>(this.apiUrl+'masterpolicy/getPremiumTransactions/');
  }
  getMasterPolicy(Id: number) {
    return this.http.get<IHome>(this.apiUrl+'masterpolicy/GetById/' + Id);
  }
  getaddOrUpdatePolicy(policy:IHome ) {
    return this.http.put<IHome>(this.apiUrl+'masterpolicy/AddUpdateMasterPolicy/',policy);
  }
  deletePolicy(id:number)
  {
    return this.http.delete<IHome>(this.apiUrl+'masterpolicy/DeleteMasterPolicy/'+id);
  }
  renewPolicy(policy:IHome){

    return this.http.post<IHome>(this.apiUrl+'masterpolicy/RenewPolicy',policy);

  }
  //for dropdowns data
  getDropdownAcc() {
    return this.http.get<Idropdown[]>(this.apiUrl+'Common/GetAccountsDropdown');
  }
  getDropdownPolT() {
    return this.http.get<Idropdown[]>(this.apiUrl+'Common/GetPolicyTypesDropdown');
  }
  getDropdownPolS() {
    return this.http.get<Idropdown[]>(this.apiUrl+'Common/GetPolicyStatusesDropdown');
  }
  getDropdownCon() {
    return this.http.get<Idropdown[]>(this.apiUrl+'Common/GetContractsDropdown');
  }
  getDropdownStates() {
    return this.http.get<Idropdown[]>(this.apiUrl+'Common/GetStatesDropDown');
  }

  getAbandonedApps(){
    return this.http.get<IabandonedApps[]>(this.apiUrl+'goapp/GetAbbandonedApps')
  }

  getAssociations(){
    return this.http.get<Iassociation[]>(this.apiUrl+'associations/GetAssociations')
  }
  getAddnewAssociations(association:IaddnewAssociations){
    return this.http.put< IaddnewAssociations>(this.apiUrl+'associations/AddOrUpdateAssociation',association)
  }
  getAssociationDetials(Id: number) {
    return this.http.get(this.apiUrl+'associations/GetAssociationDetails/' + Id);
  }
  IsUserValidated(Id:number){
    return this.http.get<boolean>(this.apiUrl+'User/IsUserValidated/' + Id);
  }
}
